let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("0l0tL")).then(() => parcelRequire('gsb8W'));